import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a href="https://github.com/byteGabo" className="home__social-icon" target="_blank" rel="noreferrer">
        <i class="uil uil-github-alt"></i>
      </a>

      <a href="https://www.linkedin.com/in/gabriel-ch/" className="home__social-icon" target="_blank" rel="noreferrer">
      <i class="uil uil-linkedin-alt"></i>
      </a>

      <a href="https://www.behance.net/gabrielchv" className="home__social-icon" target="_blank" rel="noreferrer">
      <i class="uil uil-behance-alt"></i>
      </a>
    </div>
  );
};

export default Social;
